import React from "react";
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import styled from "@emotion/styled";
import "react-loading-skeleton/dist/skeleton.css";

const SkeletonContainer = styled("div")({
  boxSizing: "border-box",
  border: "1px solid #EBEDED",
  padding: 16,
  borderRadius: 10,
  fontSize: 16,
  fontFamily: "pf_highway_sans_pro_lightRg",
  width: "100%",
  border: "none",
});

function Box({ children }) {
  return (
    <div
      style={{
        display: "block",
        lineHeight: 1,
        marginBottom: "8px",
        width: "100%",
      }}
    >
      {children}
    </div>
  );
}

const OrganizerSkeleton = () => {
  return (
    <div className="SingleOrganizerContainer">
      <SkeletonContainer>
        <SkeletonTheme
          baseColor="#D8DBE0"
          highlightColor="#EDF1F6"
          borderRadius={"4px"}
        >
          <div style={{ marginBottom: "24px" }}>
            <Skeleton height={31} width={160} />
          </div>
          <Skeleton wrapper={Box} count={3} />
        </SkeletonTheme>
      </SkeletonContainer>
    </div>
  );
};

export default OrganizerSkeleton;
